import * as React from "react";
import type { SVGProps } from "react";
const SvgFreebirdAirlines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <g fill="#0055a4">
      <path d="M2 33.176c2.367 2.78 4.894 9.843 13.191 11.377 3.676.682 7.456-.537 10.458-1.692 3.47-1.338 6.158-3.686 8.326-5.744 7.896-7.48 9.355-13.89 14.025-10.938-1.014-1.578-2.146-3.796-3.44-5.091-2.394-2.025-5.178-1.305-8.617 2.196-6.063 6.106-12.325 12.672-17.74 15.624C12.919 41.775 6.676 37.966 2 33.176" />
      <path d="M11.91 5.25c-1.318 1.951-5.972 4.877-4.58 10.1.611 2.255 1.818 3.812 3.293 5.097 1.802 1.595 3.968 2.717 5.674 3.656 6.193 3.417 9.78 4.399 8.839 7.765.79-.9 1.8-2.198 2.588-3.1 1.566-1.554 1.157-4.897-1.693-6.342-4.975-2.557-10.283-5.157-13.171-7.9-2.824-2.694-2.987-5.645-.95-9.276" />
    </g>
  </svg>
);
export default SvgFreebirdAirlines;
